import PropTypes from 'prop-types'
import React from 'react'

import DynamicImage from 'components/DynamicImage'
import FrameMacStraight from 'components/FrameMacStraight'
import useInViewCommon from 'hooks/useInViewCommon'
import useSwiper from 'hooks/useSwiper'
import useSwiperLoader from 'hooks/useSwiperLoader'

import { ControlSliderArrowsStyled, FrameMacSlide } from './styles'

const SLIDER_DIR = 'results'
const SLIDER_CONFIG = {
  slidesPerView: 1,
  autoHeight: true,
}

/**
 * SliderFrameMacStraight
 *
 * @param {object} props - properties of component
 * @returns {node} SliderFrameMacStraight
 */
const SliderFrameMacStraight = ({
  images,
  descrArray,
  staticPath,
  isLightColor,
}) => {
  const { activeIndex, onGoLeft, onGoRight, updateSwiper } = useSwiper()
  const [ref, inView] = useInViewCommon()
  const { Swiper, swiperLoaded } = useSwiperLoader({ inView })
  const path = `${staticPath}/${SLIDER_DIR}`

  return (
    <>
      <FrameMacStraight
        ref={ref}
        className="mt-4 mx-auto"
        alt={'personal account screenshot'}
        node={
          swiperLoaded ? (
            <Swiper {...SLIDER_CONFIG} getSwiper={updateSwiper}>
              {images.map((image, key) => (
                <FrameMacSlide key={key}>
                  <DynamicImage
                    image={`${path}/${image}`}
                    imageSizes={{
                      xs: 500,
                      md: 700,
                    }}
                    alt={image}
                  />
                </FrameMacSlide>
              ))}
            </Swiper>
          ) : (
            <FrameMacSlide>
              <DynamicImage
                image={`${path}/${images[0]}`}
                imageSizes={{
                  xs: 500,
                  md: 700,
                }}
                alt={images[0]}
              />
            </FrameMacSlide>
          )
        }
      />
      <ControlSliderArrowsStyled
        descriptions={descrArray}
        isWide={true}
        amount={descrArray.length}
        activeIndex={activeIndex}
        handleLeft={onGoLeft}
        handleRight={onGoRight}
        isLightColor={isLightColor}
      />
    </>
  )
}

SliderFrameMacStraight.propTypes = {
  /** Array with descriptions */
  descrArray: PropTypes.array.isRequired,

  /** Array of images' names */
  images: PropTypes.array.isRequired,

  /** Path to a directory with page's files */
  staticPath: PropTypes.string.isRequired,

  /** Flag to set light color for controls */
  isLightColor: PropTypes.bool,
}

export default SliderFrameMacStraight
